import { merge } from '../helper';

// ----------------------------------------------------------------------------

function start(config: Record<string, any> = {}): Promise<any> | number {
    // Default Config
    const defConfig: Record<string, any> = {
        type: 'timeout',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const src: Record<string, any> = {};

    // Function Timeout
    const fnTimeout = function (): any {
        // If using element
        if (defConfig.element instanceof HTMLElement) {
            // Get element timeout
            src.getTimeout = defConfig.element[defConfig.type];
            // If there is timeout
            if (src.getTimeout > 0) {
                clearTimeout(src.getTimeout);
            }
        }

        // ----------------------------------------------------------------

        // Set Timeout
        src.setTimeout = setTimeout(function (): any {
            if (src.setTimeout > 0) {
                clearTimeout(src.setTimeout);
            }

            // If using function action
            if (typeof defConfig.fnAction === 'function') {
                defConfig.fnAction();
            }
        }, defConfig.time);

        // ----------------------------------------------------------------

        // If using element
        if (defConfig.element instanceof HTMLElement) {
            // Set element timeout
            defConfig.element[defConfig.type] = src.setTimeout;
        }

        // ----------------------------------------------------------------

        // Return
        return src.setTimeout;
    };

    // ------------------------------------------------------------------------

    // If using promise
    if (defConfig.promise === true) {
        // New Promise
        const promise = new Promise<void>(function (resolve): any {
            // Get function action
            const fnAction = defConfig.fnAction;

            // Function Action
            defConfig.fnAction = function (): any {
                // If using function action
                if (typeof fnAction === 'function') {
                    fnAction();
                }

                // Resolve
                resolve();
            };

            // Function Timeout
            fnTimeout();
        });

        // Return
        return promise;
    }
    // Is default
    else {
        // Function Timeout
        const setTimeout = fnTimeout();

        // Return
        return setTimeout;
    }
}

// ----------------------------------------------------------------------------

export { start };
